var pageAbout = {
    selectedDivision = '',
    $cardsContainer = jQuery(".team-cards-container"),
    $displayContainer = jQuery(".grid-team-card"),

    searchCard = function() {
        var self = this;
        this.$displayContainer.empty();
        var $selecteds = [];
        this.$cardsContainer.children().each(function() {
            var $card = $(this);
            if ($card.is('.'+self.selectedDivision)) {
                $selecteds.push($card);
            }
        });
        $.each($selecteds, function() {
            var $clone = $(this).clone();
            $clone.appendTo(self.$displayContainer);
        });
    }
};

(function ($) {

    $(".js-trigger-facility-show-more").on('click', function() {
        $galleryKey = this.getAttribute('data-gallery');
        $ContainerGallery = '.gallery-container-'+$galleryKey;
        $selected = '[data-gallery='+$galleryKey+']';
        $($selected).addClass('hide');
        $($ContainerGallery).removeClass('hide');
    });

    $(".js-trigger-filter-team").on('click', function() {
        pageAbout.selectedDivision = $(this).data('division');
        $(".js-trigger-filter-team").removeClass('filter-selected');
        $(this).addClass('filter-selected');
        pageAbout.searchCard();
    });
    $(".js-trigger-filter-team").eq(0).trigger('click');
    
})(jQuery);
